
import type { Channels } from '@eureka/shared/login-sdk';

export function useLoginSdk(channels:Channels = {}) {
    const openLoginDialog = () => {
        import('@eureka/shared/login-sdk').then(({ loginSDK }) => {
            loginSDK.setChannels(channels);
            loginSDK.open({
                withoutClose: true,
            }).then(() => {
                window.location.reload();
            })
        });
    }

    return {
        openLoginDialog,
    }
}
